export default __webpack_public_path__ + "static/media/man-correct.e685f4d3.svg";